module.exports = __webpack_public_path__ + "static/img/0006.ac1d3489.png";